import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Nav, Navbar } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import Menu from "../assets/images/icons/toggle-menu.svg";

import GamesSearchModal from "../views/components/GamesSearchModal";
import ModalWrapper from "./ModalWrapper";
import { APP_CONST, COMMON_HEADER_LINKS } from "../config/const";
import { getNotifications } from "../redux/app/actions";

const Header = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const htmlElement = document.documentElement;
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState(APP_CONST.AUTH_MODAL.LOGIN);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const handleToggleClick = () => {
    htmlElement.style.overflow = "hidden";
    document.body.classList.add("leftbar-opened");
  };

  const headerLinks = [
    ...COMMON_HEADER_LINKS,
    {
      id: 5,
      name: "Aviator"
    },
    {
      id: 6,
      name: "Casino"
    },
    {
      id: 7,
      name: "Sports"
    }
  ];

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header beforeheader">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="leftbar_toggle ">
                    <Button
                      variant="primary"
                      onClick={() => handleToggleClick()}
                    >
                      <img src={Menu} />
                    </Button>
                  </div>
                  <div className="logo">
                    <a href="/">
                      <img src={appDetails?.LOGO_URL} alt="Logo" height={38} />
                    </a>
                  </div>
                  <div className="headerLinks d-none d-xl-block">
                    {headerLinks.map((item, id) => {
                      return (
                        <a
                          onClick={() => {
                            if (item?.href) {
                              navigate(item.href);
                            } else {
                              handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                            }
                          }}
                          key={id}
                        >
                          {item?.name}
                        </a>
                      );
                    })}
                  </div>
                </div>

                <div className="headerRight">
                  <Button
                    variant="primary"
                    onClick={() => {
                      handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                    }}
                    className="button-primary btn_signin"
                  >
                    Login
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      handleModalShow(APP_CONST.AUTH_MODAL.MOBILE_NUMBER);
                    }}
                    className="button-primary btn_signup  ms-2"
                  >
                    SIGN UP
                  </Button>

                  <div className="d-none d-md-block">
                    <GamesSearchModal />
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {showAuthModals && (
            <ModalWrapper
              defaultShow={defaultModal}
              setShowAuthModals={setShowAuthModals}
            />
          )}
        </Container>
      </header>
    </>
  );
};

export default Header;
